import { render, staticRenderFns } from "./RankGoods.vue?vue&type=template&id=6c5d5dc6&scoped=true"
import script from "./RankGoods.vue?vue&type=script&lang=js"
export * from "./RankGoods.vue?vue&type=script&lang=js"
import style0 from "./RankGoods.vue?vue&type=style&index=0&id=6c5d5dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d5dc6",
  null
  
)

export default component.exports